export default __webpack_public_path__ + "assets/images/icon-mic.4238a0d077b746b9812e1179cc66eb45.svg";